// Central content for Tara Creative Group

export const IMG = {
  hero: "https://images.unsplash.com/photo-1765954079511-572f7c0072d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxoaWdoJTIwZW5kJTIwZmFzaGlvbiUyMGFkdmVydGlzaW5nJTIwY2FtcGFpZ24lMjBiaWxsYm9hcmQlMjBtb2NrdXB8ZW58MHx8fHwxNzg3MDM5NTg1fDA&ixlib=rb-4.1.0&q=85",
  billboardBuilding: "https://images.unsplash.com/photo-1560196327-cca0a731441b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMGFkdmVydGlzaW5nJTIwY2FtcGFpZ24lMjBiaWxsYm9hcmQlMjBlZGl0b3JpYWx8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  billboardPink: "https://images.unsplash.com/photo-1612332883331-e8ea07a15f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMGFkdmVydGlzaW5nJTIwY2FtcGFpZ24lMjBiaWxsYm9hcmQlMjBlZGl0b3JpYWx8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  billboardNike: "https://images.unsplash.com/photo-1647923822124-d8f3efb8adee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMGFkdmVydGlzaW5nJTIwY2FtcGFpZ24lMjBiaWxsYm9hcmQlMjBlZGl0b3JpYWx8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  billboardDkny: "https://images.pexels.com/photos/31165586/pexels-photo-31165586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  brandOne: "https://images.unsplash.com/photo-1763705857736-2b4f16a33758?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxicmFuZCUyMGlkZW50aXR5JTIwZGVzaWduJTIwbW9ja3VwJTIwc3R1ZGlvfGVufDB8fHx8MTc4NzAzOTY0MXww&ixlib=rb-4.1.0&q=85",
  brandPosters: "https://images.unsplash.com/photo-1762365189058-7be5b07e038b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxicmFuZCUyMGlkZW50aXR5JTIwZGVzaWduJTIwbW9ja3VwJTIwc3R1ZGlvfGVufDB8fHx8MTc4NzAzOTY0MXww&ixlib=rb-4.1.0&q=85",
  brandCards: "https://images.pexels.com/photos/4466104/pexels-photo-4466104.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  brandCardsBlack: "https://images.pexels.com/photos/4466420/pexels-photo-4466420.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cosmeticCrystal: "https://images.pexels.com/photos/8128067/pexels-photo-8128067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cosmeticPink: "https://images.pexels.com/photos/27462682/pexels-photo-27462682.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  skincare: "https://images.pexels.com/photos/8015792/pexels-photo-8015792.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  socialMac: "https://images.unsplash.com/photo-1620313924455-70c030910dcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGZsYXRsYXl8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  socialCam: "https://images.unsplash.com/photo-1769689268229-3e9c9ddaf1ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGZsYXRsYXl8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  team1: "https://images.unsplash.com/photo-1603201667230-bd139210db18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHRlYW0lMjB3b3JraW5nJTIwYWdlbmN5JTIwb2ZmaWNlfGVufDB8fHx8MTc4NzAzOTY0MXww&ixlib=rb-4.1.0&q=85",
  team2: "https://images.unsplash.com/photo-1603195827187-459ab02554a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMHRlYW0lMjB3b3JraW5nJTIwYWdlbmN5JTIwb2ZmaWNlfGVufDB8fHx8MTc4NzAzOTY0MXww&ixlib=rb-4.1.0&q=85",
  team3: "https://images.unsplash.com/photo-1666698809123-44e998e93f23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMHRlYW0lMjB3b3JraW5nJTIwYWdlbmN5JTIwb2ZmaWNlfGVufDB8fHx8MTc4NzAzOTY0MXww&ixlib=rb-4.1.0&q=85",
  ecomMango: "https://images.unsplash.com/photo-1539278383962-a7774385fa02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxlY29tbWVyY2UlMjBmYXNoaW9uJTIwb25saW5lJTIwc3RvcmV8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  ecomBags: "https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2UlMjBmYXNoaW9uJTIwb25saW5lJTIwc3RvcmV8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  ecomStore: "https://images.unsplash.com/photo-1677693972403-db681288b5da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxlY29tbWVyY2UlMjBmYXNoaW9uJTIwb25saW5lJTIwc3RvcmV8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  studioSoftbox: "https://images.unsplash.com/photo-1527011046414-4781f1f94f8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxwaG90b2dyYXBoZXIlMjBzdHVkaW8lMjBjYW1lcmElMjBiZWhpbmQlMjBzY2VuZXN8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  studioCam: "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwaG90b2dyYXBoZXIlMjBzdHVkaW8lMjBjYW1lcmElMjBiZWhpbmQlMjBzY2VuZXN8ZW58MHx8fHwxNzg3MDM5NjQxfDA&ixlib=rb-4.1.0&q=85",
  studioBw: "https://images.pexels.com/photos/11388583/pexels-photo-11388583.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aboutHero: "https://images.unsplash.com/photo-1736580602037-5c1da2d7e388?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwZWxlZ2FudCUyMGNyZWF0aXZlJTIwc3R1ZGlvJTIwaW50ZXJpb3IlMjBhZXN0aGV0aWN8ZW58MHx8fHwxNzg3MDQ4MjUxfDA&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  email: "enquiries@taracreativegroup.com",
  phone: "+91 9833974313",
  phoneHref: "+919833974313",
  location: "Plot No. 342, 1st Floor, Barrister Nath Pai Marg, Mazgaon, Mumbai, Maharashtra 400010 (next to Jhaveri Honda)",
  instagram: "https://www.instagram.com/taracreativegroup?igsh=ajBzYmx5ZmFmZDRp&utm_source=qr",
  linkedin: "https://www.linkedin.com/company/tara-creative-group/",
  youtube: "https://www.youtube.com/@TaraCreativegroup",
  facebook: "https://www.facebook.com/share/1Ejgo8vX2n/?mibextid=wwXIfr",
};

export const SOCIALS = [
  { label: "Instagram", href: CONTACT.instagram, icon: "instagram" },
  { label: "LinkedIn", href: CONTACT.linkedin, icon: "linkedin" },
  { label: "YouTube", href: CONTACT.youtube, icon: "youtube" },
  { label: "Facebook", href: CONTACT.facebook, icon: "facebook" },
];

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Why Tara", path: "/why-tara" },
  { label: "Our Process", path: "/process" },
  { label: "Clients", path: "/clients" },
  { label: "Contact", path: "/contact" },
];

export const SERVICES = [
  {
    num: "01",
    slug: "brand-strategy",
    name: "Brand Strategy",
    short: "The strategic foundation that gives your brand clarity, purpose and a distinctive position.",
    headline: ["DEFINE YOUR", "DIRECTION."],
    intro: "We establish the strategic foundation that gives your brand clarity, purpose and a distinctive position in the market.",
    capabilities: ["Brand Positioning", "Audience Insights", "Brand Messaging", "Brand Voice & Tone", "Creative Strategy", "Brand Direction"],
    images: [IMG.brandPosters, IMG.brandOne],
  },
  {
    num: "02",
    slug: "creative-direction",
    name: "Creative Direction",
    short: "Turning strategy into distinctive visual worlds, concepts and campaign languages.",
    headline: ["TURN IDEAS INTO", "VISUAL WORLDS."],
    intro: "We shape the creative vision — translating strategy into distinctive ideas, art direction and campaign concepts that feel unmistakably yours.",
    capabilities: ["Creative Concepts", "Art Direction", "Visual Storytelling", "Campaign Concepts", "Visual Direction", "Campaign Look & Feel"],
    images: [IMG.studioBw, IMG.billboardPink],
  },
  {
    num: "03",
    slug: "branding-visual-identity",
    name: "Branding & Visual Identity",
    short: "Distinctive, consistent identity systems that make your brand instantly recognisable.",
    headline: ["MAKE YOUR BRAND", "RECOGNISABLE."],
    intro: "We craft complete visual identity systems — from logo to packaging — that make your brand instantly recognisable across every touch point.",
    capabilities: ["Logo Design", "Visual Identity", "Colour Systems", "Typography", "Brand Guidelines", "Packaging", "Marketing Collateral", "Digital Brand Assets"],
    images: [IMG.brandOne, IMG.brandCards, IMG.cosmeticCrystal],
  },
  {
    num: "04",
    slug: "advertising",
    name: "Advertising",
    short: "Campaigns that combine strategic thinking, compelling creative and clear communication.",
    headline: ["GET SEEN.", "GET REMEMBERED."],
    intro: "We create advertising campaigns that combine strategic thinking, compelling creative and clear communication to put brands in front of the right audiences.",
    capabilities: ["Digital Advertising", "Social Advertising", "Print Advertising", "Outdoor Advertising", "Campaign Concepts", "Ad Creative", "Copywriting", "Campaign Strategy"],
    images: [IMG.billboardBuilding, IMG.billboardDkny, IMG.billboardNike, IMG.billboardPink],
    feature: true,
  },
  {
    num: "05",
    slug: "digital-marketing",
    name: "Digital Marketing",
    short: "Where creativity meets reach — digital strategy, campaigns and audience engagement.",
    headline: ["WHERE CREATIVITY", "MEETS REACH."],
    intro: "We build digital marketing that connects creativity with performance — reaching the right audiences and turning attention into meaningful brand growth.",
    capabilities: ["Digital Strategy", "Digital Campaigns", "Audience Engagement", "Digital Creative", "Online Brand Communication", "Online Brand Growth"],
    images: [IMG.socialMac, IMG.ecomStore],
  },
  {
    num: "06",
    slug: "social-media-marketing",
    name: "Social Media Marketing",
    short: "Make your brand part of the conversation with strategy, content and community.",
    headline: ["MAKE YOUR BRAND PART", "OF THE CONVERSATION."],
    intro: "We help brands show up with intention on social — combining strategy, creative content and community engagement to build a presence people follow.",
    capabilities: ["Social Media Strategy", "Content Planning", "Social Media Management", "Creative Content", "Social Campaigns", "Community Engagement", "Social Media Branding"],
    images: [IMG.socialCam, IMG.socialMac, IMG.cosmeticPink],
    grid: true,
  },
  {
    num: "07",
    slug: "content-creation",
    name: "Content Creation",
    short: "Stories worth stopping for — photography, video and branded content.",
    headline: ["STORIES WORTH", "STOPPING FOR."],
    intro: "We produce content that earns attention — photography, video and branded storytelling crafted to make people pause, feel and remember.",
    capabilities: ["Photography", "Video Content", "Social Media Content", "Campaign Assets", "Branded Content", "Visual Storytelling", "Creative Concepts"],
    images: [IMG.studioSoftbox, IMG.studioCam, IMG.studioBw],
  },
  {
    num: "08",
    slug: "ecommerce",
    name: "E-commerce",
    short: "Turning visibility into sales through brand, design, content and experience.",
    headline: ["TURN VISIBILITY", "INTO SALES."],
    intro: "We create e-commerce experiences that combine brand, design, content and customer experience to make online shopping engaging, intuitive and conversion-focused.",
    capabilities: ["E-commerce Strategy", "Online Store Development", "E-commerce Branding", "Product Presentation", "Product Content", "Website & Store Design", "Customer Experience", "E-commerce Campaigns", "Conversion-Focused Creative"],
    images: [IMG.ecomMango, IMG.ecomBags, IMG.cosmeticPink, IMG.ecomStore],
    flow: ["Product", "Website", "Social", "Campaign", "Conversion"],
    feature: true,
  },
  {
    num: "09",
    slug: "campaign-development",
    name: "Campaign Development",
    short: "One idea, many touch points — campaigns that extend across every platform.",
    headline: ["ONE IDEA.", "MANY TOUCH POINTS."],
    intro: "We develop campaigns built on a single strong idea and extend it seamlessly across digital, social, print and outdoor for maximum impact.",
    capabilities: ["Campaign Strategy", "Creative Concepts", "Campaign Art Direction", "Digital Campaigns", "Social Campaigns", "Print & Outdoor Creative", "Campaign Content"],
    images: [IMG.billboardBuilding, IMG.socialMac, IMG.cosmeticCrystal],
  },
  {
    num: "10",
    slug: "pmo",
    name: "PMO",
    short: "Project Management Office — structure, coordination and accountability from planning to delivery.",
    headline: ["FROM STRATEGY", "TO EXECUTION."],
    intro: "Our PMO — Project Management Office — approach brings structure, coordination and accountability to complex projects, helping teams stay aligned from planning through delivery.",
    capabilities: ["Project Planning", "Project Coordination", "Timeline Management", "Milestone Management", "Team Coordination", "Resource Management", "Workflow Management", "Progress Tracking", "Reporting", "Delivery Management"],
    images: [IMG.team1, IMG.team2, IMG.team3],
    fullTitle: "Project Management Office",
    feature: true,
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

export const PILLARS = [
  { num: "01", title: "Strategic Thinking", text: "We start with understanding — the brand, the audience, the goals and the challenges." },
  { num: "02", title: "Creative Excellence", text: "We turn strategy into distinctive ideas that stand apart and stay memorable." },
  { num: "03", title: "Collaborative Approach", text: "We believe great work is built together, as an extension of your team." },
  { num: "04", title: "Purposeful Execution", text: "Every creative decision has a reason and a role in the bigger picture." },
  { num: "05", title: "Built For Growth", text: "We create foundations that can evolve and scale with your business." },
];

export const PROCESS = [
  { num: "01", title: "Discover", text: "We understand the brand, audience, goals and challenges." },
  { num: "02", title: "Define", text: "We establish the strategic and creative direction." },
  { num: "03", title: "Create", text: "We develop the concepts, identity, content and creative assets." },
  { num: "04", title: "Execute", text: "We bring the creative vision to life across the right platforms." },
  { num: "05", title: "Grow", text: "We refine, strengthen and build for long-term growth." },
];

export const CASE_STUDIES = [
  {
    slug: "aurelle",
    tag: "Skincare / Branding & E-commerce",
    title: "Aurelle Skincare",
    image: IMG.skincare,
    objective: "Launch a modern skincare label with a premium, quietly confident identity.",
    strategy: "Positioned Aurelle around 'considered simplicity' — fewer products, deeper trust.",
    creative: "A restrained visual identity: soft neutrals, editorial typography, tactile packaging.",
    execution: "Brand system, packaging, product photography and a conversion-focused store.",
    outcome: "A cohesive brand world that lifted first-month online conversion and repeat purchase.",
  },
  {
    slug: "meridian",
    tag: "Fashion / Advertising Campaign",
    title: "Meridian Outerwear",
    image: IMG.billboardDkny,
    objective: "Reintroduce a heritage outerwear brand to a younger, urban audience.",
    strategy: "Built a bold outdoor-led campaign around movement, city and self-expression.",
    creative: "High-contrast fashion photography paired with confident, minimal copy lines.",
    execution: "Outdoor, digital and social advertising rolled out across key metro markets.",
    outcome: "A recognisable campaign look that drove a measurable lift in brand recall.",
  },
  {
    slug: "lumen",
    tag: "Beauty / Content & Social",
    title: "Lumen Beauty",
    image: IMG.cosmeticCrystal,
    objective: "Turn a product-led beauty brand into a content-led social presence.",
    strategy: "Developed a repeatable content system built for stopping the scroll.",
    creative: "Studio product photography, tactile flat-lays and a distinctive social grid.",
    execution: "Monthly content production, social calendar and paid social campaigns.",
    outcome: "A consistent, ownable feed that grew engaged community and saves.",
  },
  {
    slug: "north-atelier",
    tag: "Retail / E-commerce Experience",
    title: "North Atelier",
    image: IMG.ecomMango,
    objective: "Rebuild an online store that felt as considered as the product.",
    strategy: "Mapped the full journey from product to campaign to conversion.",
    creative: "Editorial product presentation, clean UI and campaign-driven landing pages.",
    execution: "Store design, product content and seasonal e-commerce campaigns.",
    outcome: "A smoother, more intuitive shopping experience built to convert.",
  },
];

export const CLIENTS = [
  { name: "Pepsi", logo: "/logos/client-pepsi.jpg" },
  { name: "Thums Up", logo: "/logos/client-thums-up.jpg" },
  { name: "Kurkure", logo: "/logos/client-kurkure.jpg" },
  { name: "Raymond", logo: "/logos/client-raymond.jpg" },
  { name: "Rado", logo: "/logos/client-rado.jpg" },
  { name: "Bank of Baroda", logo: "/logos/client-bank-of-baroda.jpg" },
  { name: "LIC", logo: "/logos/client-lic.jpg" },
  { name: "Mumbai Bank", logo: "/logos/client-mumbai-bank.jpg" },
  { name: "Star Plus", logo: "/logos/client-star-plus.jpg" },
  { name: "NDTV India", logo: "/logos/client-ndtv-india.jpg" },
  { name: "Radio Mirchi", logo: "/logos/client-radio-mirchi.jpg" },
  { name: "Filmfare", logo: "/logos/client-filmfare.jpg" },
  { name: "Mid-Day", logo: "/logos/client-mid-day.jpg" },
  { name: "MyGlamm", logo: "/logos/client-myglamm.jpg" },
  { name: "Mysore Sandal", logo: "/logos/client-mysore-sandal.jpg" },
  { name: "Wingreens Farms", logo: "/logos/client-wingreens.jpg" },
  { name: "House of Yumii", logo: "/logos/client-house-of-yumii.png" },
  { name: "Ganesh Tea", logo: "/logos/client-ganesh-tea.jpg" },
  { name: "Paneri Sarees", logo: "/logos/client-paneri-sarees.jpg" },
  { name: "Yellow Pages", logo: "/logos/client-yellow-pages.jpg" },
  { name: "Action", logo: "/logos/client-action.jpg" },
  { name: "DTDC", logo: "/logos/client-dtdc.png" },
];
